import React from 'react';
import moment from 'moment';
import ConversationTimeline from 'components/manager-dashboard/conversation-timeline/ConversationTimeline';
import connectToStores from 'alt-utils/lib/connectToStores';
import ManagerDashboardStore from 'stores/ManagerDashboardStore';
import ManagerDashboardActions from 'actions/ManagerDashboardActions';
import DashV2MainWidgetLoader from 'components/dashboard/DashV2MainWidgetLoader';
import {getManagerIdIfNotAuthUser} from 'components/StatsPage2.utils';

const widgetId = 'conversation_timeline';
const WIDGET_TYPE = 'CONVERSATION_TIMELINE';

class ManagerTodaysConversations extends React.Component {
  static getStores() {
    return [ManagerDashboardStore];
  }

  static getPropsFromStores() {
    const store = ManagerDashboardStore.getState();
    const {widgets, widgetState} = store;
    return {widgets, widgetState};
  }

  componentDidMount() {
    const {selectedTeam} = this.props;
    const teamId = selectedTeam ? selectedTeam.id : null;
    const widgetConfig = {
      teamId,
      // set the date to the browser's "today" (as a string, not a moment object),
      // because otherwise moment will format with UTC timezone
      date: moment().format('YYYY-MM-DD'),
      widgetId: widgetId,
      widgetType: WIDGET_TYPE,
    };

    ManagerDashboardActions.getWidget.defer([widgetConfig, getManagerIdIfNotAuthUser(this.props)]);
  }

  render() {
    if (!this.props.widgets) return null;

    const widgetState = this.props.widgetState.get(widgetId);
    const widget = this.props.widgets.get(widgetId);

    if (!widget) return <DashV2MainWidgetLoader />;

    return (
      <div className="standalone-widget-wrapper">
        <ConversationTimeline
          key={widget.widgetId}
          widgetState={widgetState}
          onBehalfOfManagerId={getManagerIdIfNotAuthUser(this.props)}
          selectedTeam={this.props.selectedTeam}
          sortByNumCalls={true}
          {...widget}
          /* need to do this after the above widget deconstruction, because the component
          ConversationTimeline actually uses the widgetType for further widget data retrieval */
          widgetType={WIDGET_TYPE}
          location={this.props.location}
          adminId={this.props.adminId}
          managerId={this.props.managerId}
          coachId={this.props.coachId}
        />
      </div>
    );
  }
}

export default connectToStores(ManagerTodaysConversations);
